<template>
    <div class="wrapper">
      <div class="content-container">
        <div class="stingy-card">
  <h2>🌟✨ "The Marvelous Market Mosaic: RiskyPaws' Guide to the Heatmap!" ✨🌟</h2>
  
  <p>Hey there, RiskyPaws adventurers! Have you ever wondered how the big cats of Wall Street – the institutional traders, including RiskyPaws' very own hooman – keep their paws on the pulse of the market? The secret lies in a dazzling tool called the stock market heatmap! 📊🔥
  
  Picture a colorful patchwork quilt, each square shimmering with different hues. That's our heatmap! It's not just any quilt, though – it's a magical window into the hustle and bustle of the stock market, where every color and shade tells a tale of ups and downs, twists and turns. 🌈
  
  <br><br>🐾 A Purr-fect Panorama: For our savvy hooman traders, this heatmap is like having super-cat vision! With just a glance, they can see which stocks are the cool cats (in blue) taking a catnap, and which ones are hot on the prowl (in red), scaling the market trees. It's a purr-fect panorama of the entire market forest!
  
  <br><br>🔍 Change the Markets and Indicators: But wait, there's more! With a twitch of their whiskers, these market maestros can change the view! Want to peek into the tech jungle or the energy savannah? Just a click, and the heatmap shifts to show different sectors. And for those curious kittens who love to dig deeper, indicators galore let them sniff out trends, patterns, and all the hidden mice (or should we say, insights)!
  
  <br><br>🐱 RiskyPaws' Hooman's Secret: RiskyPaws' hooman, a seasoned market whisperer, uses this tool to leap and bound through complex market trees. It's like having a map to hidden treasure troves of stocks, helping to make decisions that are not just smart, but whisker-tinglingly intuitive!
  
  <br><br>🌍 An Overview of the Market Jungle: For our adventurers, the heatmap is more than a tool – it's a guide through the vast, wild world of stocks and shares. It shows where the market is purring contently and where it's hissing, letting traders of all stripes – from the big lions of institutions to the independent lynxes – navigate the financial wilderness with confidence.
  
  So, there you have it, dear RiskyPaws explorers! The stock market heatmap isn't just a patchwork of colors; it's a tapestry of market stories, a crystal ball into the heart of the financial jungle. Remember, in the game of stocks, a quick purr-ek at the heatmap can be the difference between a daring leap or a cautious paw-step!
  
  Keep those whiskers twitching and eyes wide open, for the market, just like a curious cat, is always full of surprises! 🌟🐾💼</p>
  
  
  
    <div class="tradingview-widget-container" ref="widgetContainer">
      <div class="tradingview-widget-container__widget"></div>
    </div></div></div></div><br><br><br><br><br><br>
  </template>
  
  <script>
  import { ref, onMounted } from 'vue';
  
  export default {
    setup() {
      const widgetContainer = ref(null);
  
      onMounted(() => {
        const script = document.createElement('script');
        script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-stock-heatmap.js';
        script.async = true;
        script.type = 'text/javascript';
        script.innerHTML = JSON.stringify({
          "exchanges": ["NASDAQ"],
          "dataSource": "AllUSA",
          "grouping": "sector",
          "blockSize": "market_cap_basic",
          "blockColor": "change",
          "locale": "en",
          "symbolUrl": "",
          "colorTheme": "light",
          "hasTopBar": false,
          "isDataSetEnabled": true,
          "isZoomEnabled": true,
          "hasSymbolTooltip": true,
          "width": "1200",
          "height": "1000"
        });
        widgetContainer.value.appendChild(script);
      });
  
      return {
        widgetContainer
      };
    }
  };
  </script>
  
  <style scoped>
  .tradingview-widget-container {
    width: 100%; /* Ensure full width */
    /* You can set a minimum height if needed */
  
  }
  
  
  .wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  }
  
  .content-container {
  background-color: #4A148C ;  /* Light orange color */
  color: black;
  padding: 20px;
  border-radius: 20px;  /* Adjust this value to your preference */
  overflow: hidden; 
  }
  .stingy-card {
  flex: 1;  /* Take up equal width as the iframe */
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: white
  }
  
  .stylish-links {
  background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  }
  
  .stylish-links h3 {
  color: #333;
  font-size: 1.4em;
  margin-bottom: 15px;
  }
  
  .stylish-links ul {
  list-style: none;
  padding: 0;
  }
  
  .stylish-links ul li {
  background-color: #fff;
  margin: 10px 0;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  }
  
  .stylish-links ul li a {
  color: black;
  text-decoration: none;
  font-weight: bold;
  }
  
  .stylish-links ul li:hover {
  background-color: #4A148C;
  }
  
  .stylish-links ul li:hover a {
  color: #fff;
  }

  @media (max-width: 600px) {
  .tradingview-widget-container, .tradingview-widget-container__widget {
    width: 100% !important;
    height: 100%; 
  }
  /* Adjust content container for better mobile viewing */
  .content-container {
    padding: 10px;
    border-radius: 15px;
  }
}
  </style>
  